import { createRoute, redirect } from '@tanstack/react-router';
import { pharmacyLabRoute } from 'pages/pharmacy/Labs/PharmacyLabPage/route';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

/**
 * FKS-8676 renamed the Kopilot pages from `/real_invoices` to `/kopilot/invoices`.
 * These redirects keep existing bookmarks and shared links landing on the right
 * screen. Rewriting `location.href` preserves the path params and the whole query
 * string at once, so the (large) search schemas don't need restating here.
 */

const legacyPath = '/real_invoices';
const currentPath = '/kopilot/invoices';

const invoicesRedirectRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: legacyPath,
  beforeLoad: ({ location }) => {
    throw redirect({ href: location.href.replace(legacyPath, currentPath) });
  },
});

const invoiceDetailRedirectRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: `${legacyPath}/$invoiceId`,
  params: z.object({ invoiceId: zodPathParamId }),
  beforeLoad: ({ location }) => {
    throw redirect({ href: location.href.replace(legacyPath, currentPath) });
  },
});

const labInvoiceDetailRedirectRoute = createRoute({
  getParentRoute: () => pharmacyLabRoute,
  path: `${legacyPath}/$invoiceId`,
  params: z.object({ invoiceId: zodPathParamId }),
  beforeLoad: ({ location }) => {
    throw redirect({ href: location.href.replace(legacyPath, currentPath) });
  },
});

export const legacyKopilotRedirectRoutes = [
  invoicesRedirectRoute,
  invoiceDetailRedirectRoute,
  labInvoiceDetailRedirectRoute,
];
